var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{attrs:{"dense":"","color":"transparent","flat":""}},[_vm._v(" 현재 상태 "),_c('v-spacer')],1),_c('v-divider'),_c('OwnerCurrentLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }